// mantine
import { NumberFormatter } from '@mantine/core';
// components
import { IConversationsUserPersona } from '@newo/api/gateway';
import DateTime from '@/modules/DateTime/components/DateTime';
// utils
import { cn } from '@/utils';

interface PersonaDataProps {
    className?: string;
    persona: IConversationsUserPersona;
    onSelect: (persona?: IConversationsUserPersona) => void;
}

const PersonaData = ({ className, persona }: PersonaDataProps) => {
    return (
        <div className={cn('text-xs', className)}>
            <div className="text-sm flex items-center pr-3">
                <div className="text-sm text-black truncate">
                    {persona.name}
                </div>
                <NumberFormatter
                    thousandSeparator
                    className="ml-auto"
                    value={persona.act_count}
                />
            </div>
            <div className="truncate pr-4">{persona.last_act_text}</div>
            <div>
                <DateTime
                    format="LL/dd hh:mm a"
                    value={persona.last_act_time}
                />
            </div>
        </div>
    );
};

export default PersonaData;
